export const COOKIE_ACCESS_TOKEN = 'mnpg_access_token'
export const COOKIE_REFRESH_TOKEN = 'mnpg_refresh_token'
export const COOKIE_HAS_REFRESH_TOKEN = 'mnpg_has_refresh_token'
export const COOKIE_IS_AUTHENTICATED = 'mnpg_is_authenticated'

export const HEADER_SESSION_ID = 'mnpg-session-id'
